import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';
import { WrappedFieldProps } from 'redux-form';

interface CheckboxField {
  text: string;
  checked: boolean;
}

interface CheckboxProps extends WrappedFieldProps {
  field: CheckboxField;
}

const Checkbox: React.FC<CheckboxProps> = ({ input, field: { text, checked } }) => (
  <FormGroup check>
    <Label check>
      <Input type="checkbox" {...input} checked={checked} />
      <small>{text}</small>
    </Label>
  </FormGroup>
);

export default Checkbox;
